<template>
    <div class="header-top">
        <div class="header" :style="{ background: background }">
            <div :style="{ height: statusHeight + 'px' }"></div>
            <div class="nav-bar">
                <img @click="handelBack" :src="backIcon" alt="" />
                <div :class="[ isSlotTitle && 'title', 'center', language]" ref="title">
                    <span v-if="isSlotTitle">{{ title }}</span>
                    <slot v-else name="title"></slot>
                </div>
                <div :class="[ isSlotTitle && 'operation']">
                    <slot name="operation"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { appFunc_callExit } from '@/utils/bridge'
export default {
    props: {
        statusHeight: {
            type: Number,
            default: 0
        },
        background: {
            type: String,
            default: '#ffff'
        },
        backIcon: {
            type: String,
            default: require('@/assets/icon_back.png')
        },
        title: {
            type: String,
            default: '标题'
        },
        isNavtiveBack: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            language: this.$i18n.locale,
            isSlotTitle: false,
        }
    },
    methods: {
        handelBack() {
            if(this.isNavtiveBack) {
                appFunc_callExit()
            }else {
                this.$router.back()
            }
        },
    },
    mounted() {
        this.isSlotTitle = this.$refs.title.innerText === ''
    },
}
</script>

<style lang="scss" scoped>
.nav-bar {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    font-size: 14px;
    position: relative;
    
    .header {
        transition: all 0.3s ease-in-out;
    }
    .title {
        min-width: calc(100vw - 90px);
        font-weight: 500;
        font-size: 18px;
        color: #181818;
        text-wrap: nowrap;
    }

    .center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .operation {
        width: 30px;
        height: 30px;
        font-weight: 400;
        font-size: 14px;
        color: #181818;
    }

    img,
    .empty {
        width: 30px;
        height: 30px;
    }
}
</style>